import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TabViewModule } from 'primeng/tabview';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CheckboxModule } from 'primeng/checkbox';
import { ToastModule } from 'primeng/toast';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { CardModule } from 'primeng/card';
import { RadioButtonModule } from 'primeng/radiobutton';
import { PanelModule } from 'primeng/panel';

import { ProjectUserRegisterComponent } from './components/project-user-register.component';
import { NetworkRequestRoutingModule } from './network-request-routing.module';
import { QuestionnaireComponent } from './components/questionnaire.component';
import { NetworkRequestListComponent } from './components/network-request-list.component';
import { NetworkRequestEditComponent } from './components/network-request-edit.component';
import { NewNetworkRequestComponent } from './components/new-network-request.component';
import { ControlErrorModule } from '../../../shared/directives/control-error.module';
import { BlockUIModule } from 'primeng/blockui';
import { ProgressSpinnerModule } from 'primeng/progressspinner';


@NgModule({
  declarations: [
    ProjectUserRegisterComponent,
    NewNetworkRequestComponent,
    QuestionnaireComponent,
    NetworkRequestListComponent,
    NetworkRequestEditComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    CardModule,
    ConfirmDialogModule,
    ReactiveFormsModule,
    NetworkRequestRoutingModule,
    AutoCompleteModule,
    RadioButtonModule,
    CheckboxModule,
    ButtonModule,
    DropdownModule,
    PanelModule,
    TableModule,
    ToastModule,
    InputTextModule,
    TabViewModule,
    DynamicDialogModule,
    TabViewModule,
    ControlErrorModule,
    BlockUIModule,
    ProgressSpinnerModule
  ]
})
export class NetworkRequestModule {
}
